import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import theme from "../../theme";
import Loader from "../ui/Loader";
import useTableStyles from "../../styles/useTableStyles";
import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import { useParams } from "react-router";
import formatDates from "../../util/dateFormat";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
interface LogType {
  memberEmail: string;
}

const ActivityLogTableNewUI = (props: LogType) => {
  const { memberEmail } = props;
  const tableStyle = useTableStyles();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [activityLogData, setActivityLogData] = useState([]);

  const params = useParams();
  const { memberId } = params;

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${
          process.env.REACT_APP_API_URL +
          APIConstants.getMemberLogs +
          "?email=" +
          memberEmail
        }`
      );
      const mapedData = response.data.result.map((item: any, index: any) => ({
        createdAt: formatDates(item.createdAt),
        activityTitle: item.activity,
        createdBy: item.createdBy ? item.createdBy : "-",
        emailOld: item.activityDetails.oldEmail,
        emailNew: item.activityDetails.newEmail,
        activityDetails: item.activityDetails,
      }));

      mapedData.sort(
        (
          a: { createdAt: string | number | Date },
          b: { createdAt: string | number | Date }
        ) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );
      setActivityLogData(mapedData);
    } catch (error) {
      console.error(error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Grid>
      <Box
        display={"flex"}
        flexDirection={"column"}
        width="100%"
        sx={{
          overflow: "auto",
          borderRadius: "8px",
          ...tableStyle.scrollbar,
        }}
      >
        <Table sx={{ width: "100%" }}>
          <TableHead sx={{ backgroundColor: theme.color?.tableHeader }}>
            <TableRow>
              <TableCell
                align="center"
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.tableHeader,
                  color: theme.color?.tableGrey,
                }}
              >
                Activity Title
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.tableHeader,
                  color: theme.color?.tableGrey,
                }}
              >
                Created By
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.tableHeader,
                  color: theme.color?.tableGrey,
                }}
              >
                Created Date
              </TableCell>
            </TableRow>
          </TableHead>
          {!loading ? (
            <TableBody
              sx={{
                backgroundColor: theme?.color?.background,
                width: "100%",
              }}
            >
              {activityLogData.map((activity: any) => (
                <TableRow key={activity.createdAt}>
                  <TableCell
                    align="center"
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.tableHeader,
                      alignItems: "center",
                    }}
                  >
                    {activity ? (
                      <>
                        {activity.activityTitle}
                        {activity.activityDetails?.oldEmail &&
                          activity.activityDetails?.newEmail && (
                            <Box display="flex" alignItems="center">
                              <span style={{ padding: "4px 8px" }}>
                                {activity.emailOld}
                              </span>
                              <DoubleArrowIcon fontSize="small" />
                              <span style={{ padding: "0 8px" }}>
                                {activity.emailNew}
                              </span>
                            </Box>
                          )}
                      </>
                    ) : (
                      "-"
                    )}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.tableHeader,
                    }}
                  >
                    {activity ? activity.createdBy : "-"}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.tableHeader,
                    }}
                  >
                    {activity ? activity.createdAt : "-"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableCell colSpan={6}>
                <Grid
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Loader />
                </Grid>
              </TableCell>
            </TableBody>
          )}
        </Table>
        {error && (
          <Grid
            py={2}
            width={"100%"}
            display={"flex"}
            justifyContent={"center"}
          >
            <Typography
              fontFamily={theme?.font?.fontFamily.primary}
              sx={{ color: theme.color?.tableGrey }}
            >
              Something went wrong, please try again later.
            </Typography>
          </Grid>
        )}
        {activityLogData.length === 0 && !loading && (
          <Grid
            py={2}
            width={"100%"}
            display={"flex"}
            justifyContent={"center"}
          >
            <Typography
              fontFamily={theme?.font?.fontFamily.primary}
              sx={{ color: theme.color?.tableGrey }}
            >
              No data to display
            </Typography>
          </Grid>
        )}
      </Box>
    </Grid>
  );
};

export default ActivityLogTableNewUI;
